import React, { useState, useEffect, useRef  } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import SchoolCombo from "../combos/SchoolCombo";



export default function SchoolSetDebt(props) {
    const toast = useRef(null);
    const [redirectUrl, setRedirectUrl] = useState("");
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [editFormVisible, setEditFormVisible] = useState(false);
    const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);

    
    const [currentItem, setCurrentItem] = useState(null);
    const [items, setItems] = useState([]);
    const [filterItems, setFilterItems] = useState([]);
    const LoadingRows = Array.from({length:5});

    const [school, SetSchool] = useState({});
    const [debt, setDebt] = useState()
    const [discount, setDiscount] = useState()

    useEffect(() => {
    }, []);
    const checkDataEntry = function(){
      if(school == null){
            setErrorMessage("مدرسه را انتخاب نمائید");
            setErorVisible(true);
            return false;
      }
      if(!school.id){
            setErrorMessage("مدرسه را انتخاب نمائید");
            setErorVisible(true);
            return false;
      }
      if(school.id == ""){
            setErrorMessage("مدرسه را انتخاب نمائید");
            setErorVisible(true);
            return false;
      }
      return true;
    }

    const saveItem = function(isActive){
      if(!checkDataEntry()) return;
      setSaving(true);
      var debtTemp = debt;
      var discountTemp = discount;
      if(debtTemp == null){
        debtTemp = 0;
      }
      if(discountTemp == null){
        discountTemp = 0;
      }
      var params = {login:util.getTrustedUser(), id:school.id, debt:debtTemp, discount:discountTemp};
      var url = config.Server+`/basic/school/update/set-debt`;
      console.log("params---->", params)
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  setSaving(false);
                  toast.current.show({ severity: 'info', summary: 'Info', detail: 'با موفقیت ثبت شد' });
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });

    }
    const onComboChange = function(name, value){
      var id = "";
      if(value)
        if(value.id)
          id = value.id;
      SetSchool(value);
      if(id == ""){
        setDebt(null);
        setDiscount(null);
      }
      else{
        setSaving(true);
        setDebt(null);
        setDiscount(null);
        var params = {login:util.getTrustedUser(), id:id};
        var url = config.Server+`/basic/school/get/id`;
        axios
            .post(url, params )
            .then(res => {
                var response = res.data;
                console.log(response);
                if(response.state === "ok"){
                    response = response.data;
                    console.log(response);
                    setDebt(response.debt);
                    setDiscount(response.discount);
                    setSaving(false);
                }
                else{
                    setErrorMessage(response.message);
                    setErorVisible(true);
                    setSaving(false);
                }
            })
            .catch(error => {
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
                setSaving(false);
            });
      }
      
    }
    return(      
      <>
         
          <div className="card" style={{width:"300px", borderBlockColor:"#414141"}}>
          <table style={{width:"100%"}}>
            <tbody>
              <tr><td colSpan={2}>&nbsp;</td></tr>
              <tr>
                <td colSpan={2}>
                  <SchoolCombo returnFullItem={true} includeActive={true} includeInActive={true} value={school} onChange={(val) => onComboChange('school', val)} />
                </td>
              </tr>
              <tr><td colSpan={2}>&nbsp;</td></tr>
              <tr><td colSpan={2}>بدهی</td></tr>
              <tr>
                <td>
                  <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
                    <InputNumber inputId="integeronly" value={debt} onValueChange={(e) => setDebt(e.value)} useGrouping={true}  maxLength={12} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}}/>
                  </div>
                </td>
              </tr>
              <tr><td colSpan={2}>&nbsp;</td></tr>
              <tr><td colSpan={2}>تخفیف</td></tr>
              <tr>
                <td>
                  <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
                    <InputNumber inputId="integeronly" value={discount} onValueChange={(e) => setDiscount(e.value)} useGrouping={true}  maxLength={12} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}}/>
          
                  </div>
                </td>
              </tr>   
              <tr><td colSpan={2}>&nbsp;</td></tr>          
              <tr>
                <td>
                  <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
                    <Button label="ثبت بدهی و تخفیف" icon="pi pi-plus" onClick={()=>saveItem(true)} severity="success" iconPos="right" loading={saving} style={{width:"200px"}} />                  
                  </div>
                </td>
              </tr>                          
            </tbody>
          </table>            
          </div>
          <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
            <Toast ref={toast} />
      </>  
    );
  
}
